import { Button, Heading, HStack, Text, useToast } from "@chakra-ui/react";
import axios from "axios";
import LoginForm from "components/Organismos/LoginForm";
import LoginTemplate from "components/Templates/Login";
import { LoginCredentials } from "models/auth.model";
import ForgotPasswordPage from "pages/Login/forgot-password";
import { useAuth } from "providers/auth.provider";
import { useCallback, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useQueryParam } from "utils/hooks/useQueryParam";

const LoginPage = () => {
    const [, setShowForgotPassword] = useQueryParam<boolean>('showForgotPassword');
    const navigate = useNavigate();
    const {
        signIn,
        signedIn,
        info
    } = useAuth();

    const toast = useToast();

    useEffect(() => {
        if (signedIn && info) {
            if (info.roles.length === 0) {
                navigateToNewComplaint();
            } else {
                navigateToHome();
            }
        }
    }, [signedIn, info]);

    const handleLogin = async (data: LoginCredentials) => {
        await signIn(data);
    }

    const handleFailed = (err: unknown) => {
        if (axios.isAxiosError(err)) {
            if (err.response?.data.usuario && Array.isArray(err.response.data.usuario)) {
                toast({
                    status: 'warning',
                    description: err.response.data.usuario.join('\n')
                });
            } else {
                toast({
                    status: 'warning',
                    description: 'Erro ao entrar no sistema.'
                });
            }
        }
    }

    const navigateToHome = useCallback(() => navigate('/'), []);
    const navigateToNewComplaint = useCallback(() => navigate('/newComplaint'), []);

    return (
        <>
            <LoginTemplate
                header={
                    <>
                        <Heading>Entre com sua Conta</Heading>
                        <Text>Faça o <b>login</b> para continuar.</Text>
                    </>}
                form={(
                    <LoginForm
                        onSuccess={handleLogin}
                        onFailed={handleFailed}
                    />
                )}
                bottomInformation={(
                    <HStack spacing={4}>
                        <Link to="/register"><Button variant="outline" colorScheme="main">Cadastre-se agora</Button></Link>
                        <Button variant="link" onClick={() => setShowForgotPassword(true)}>Esqueceu sua senha?</Button>
                    </HStack>
                )}
            />
            <ForgotPasswordPage />
        </>
    )
}

export default LoginPage